// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 61 ? "playing-cards" : chunkId) + "." + {"47":"7856c61241bc19642fef","61":"4dba39bb7eec3e12a7f0","411":"d86632cfdba2964a8fbd"}[chunkId] + ".js";
};